import { render, staticRenderFns } from "./TheGlobalNotifications.vue?vue&type=template&id=3213d3f8&scoped=true&"
import script from "./TheGlobalNotifications.vue?vue&type=script&lang=js&"
export * from "./TheGlobalNotifications.vue?vue&type=script&lang=js&"
import style0 from "./TheGlobalNotifications.vue?vue&type=style&index=0&id=3213d3f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3213d3f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3213d3f8')) {
      api.createRecord('3213d3f8', component.options)
    } else {
      api.reload('3213d3f8', component.options)
    }
    module.hot.accept("./TheGlobalNotifications.vue?vue&type=template&id=3213d3f8&scoped=true&", function () {
      api.rerender('3213d3f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TheGlobalNotifications.vue"
export default component.exports